export const universalDummyData = {
  // showAppoinmentData: {
  //   clinic: {
  //     productCategory: {
  //       title: "General Consultation",
  //       product_category_id: 1,
  //     },
  //     duration: 1,
  //     non_gp_product_id: null,
  //     id: 40,
  //     name: "City Medical Center",
  //     selectedClinics: ["40", "41"], // PreferredTime needs this
  //     isReshedula: false, // PreferredTime needs this
  //     calenderData: {
  //       // PreferredTime needs this
  //       appointment_id: 123,
  //     },
  //     latitude: "51.5074", // ClinicBooking needs this
  //     longitude: "0.1278", // ClinicBooking needs this
  //     address: "123 Medical St, London", // ClinicBooking needs this
  //     clinic_website_description: "<p>Modern medical facility</p>", // ClinicBooking needs this
  //     position: "Main Building", // ClinicBooking needs this
  //   },
  //   gender: "male",
  //   language: {
  //     label: "English",
  //     value: 1,
  //   },
  //   duration: 1,
  // },
  showAppoinmentData: {
    clinic: {
      productCategory: {
        title: "Health Screen",
        product_category_id: 1,
      },
      duration: 1,
      non_gp_product_id: null,
      id: 40,
      name: "City Medical Center",
      selectedClinics: ["40", "41"], // PreferredTime needs this
      isReshedula: false, // PreferredTime needs this
      calenderData: {
        // PreferredTime needs this
        appointment_id: 123,
      },
      latitude: "51.5074", // ClinicBooking needs this
      longitude: "0.1278", // ClinicBooking needs this
      address: "123 Medical St, London", // ClinicBooking needs this
      clinic_website_description: "<p>Modern medical facility</p>", // ClinicBooking needs this
      position: "Main Building", // ClinicBooking needs this
    },
    gender: "male",
    language: {
      label: "English",
      value: 1,
    },
    duration: 1,
  },
  data: {
    clinic: {
      // ClinicBooking needs this
      id: 40,
      name: "City Medical Center",
      latitude: "51.5074",
      longitude: "0.1278",
      address: "123 Medical St, London",
      clinic_website_description: "<p>Modern medical facility</p>",
      position: "Main Building",
    },
    durationObjectById: {
      1: { duration: "15" },
      2: { duration: "30" },
    },
    allClinicData: {
      data: [
        {
          id: 32,
          name: "Admin Dorset Rise (London Doctors Clinic)",
          price_bucket_id: "39",
          website_url: "https://clinic1.coma",
          address: "123 Main Streetaa",
          longitude: "12.3456789",
          latitude: "-.0930045",
          clinic_website_description: "<p>5 min walk&nbsp;</p>",
          specific_email_copy: "<p>y</p>",
          specific_sms_copy: "<p>yh</p>",
          created_at: "2025-04-28T10:47:57.737000Z",
          updated_at: "2025-05-20T14:47:33.167000Z",
          deleted_at: null,
          created_by: "USR-000000000014",
          updated_by: "USR-000000000003",
          status: "1",
          rooms: [
            {
              id: 243,
              clinic_id: "32",
              lantum_location_id: "3014744",
              semble_location_id: "null",
              created_at: "2025-05-18T13:52:33.287000Z",
              updated_at: "2025-05-20T15:14:20.767000Z",
              deleted_at: null,
              created_by: "USR-000000000003",
              updated_by: "USR-000000000003",
            },
            {
              id: 244,
              clinic_id: "32",
              lantum_location_id: "3014744",
              semble_location_id: "null",
              created_at: "2025-05-18T13:52:33.337000Z",
              updated_at: "2025-05-20T15:14:20.800000Z",
              deleted_at: null,
              created_by: "USR-000000000003",
              updated_by: "USR-000000000003",
            },
          ],
        },
        {
          id: 34,
          name: "Annual Leave (London Doctors Clinic)",
          price_bucket_id: "40",
          website_url: "https://www.londondoctorsclinic.co.uk/clinics/chiswick",
          address: "149 Chiswick High Rd, Chiswick, London, W4 2DT",
          longitude: "-.2575115",
          latitude: "51.4925120",
          clinic_website_description:
            "<p>Randox Health building on Chiswick High Road. The closest station is Turnham Green. Exit Turnham Green Station and head southeast on Chiswick High Road. Continue walking straight on Chiswick High Road for approximately 1 minute until you reach your destination at 149 Chiswick High Road. Along the way, you'll pass various shops, cafes, and restaurants and you can find us directly across the road from Joe &amp; The Juice.</p>",
          specific_email_copy: "<p>It is next to the Chiswick HIgh Street</p>",
          specific_sms_copy: "<p>It is next to the Chiswick HIgh Street</p>",
          created_at: "2025-04-29T13:46:48.053000Z",
          updated_at: "2025-06-08T11:18:09.333000Z",
          deleted_at: null,
          created_by: "USR-000000000014",
          updated_by: "USR-000000000012",
          status: "1",
          rooms: [
            {
              id: 190,
              clinic_id: "34",
              lantum_location_id: "3014987",
              semble_location_id: "null",
              created_at: "2025-05-14T13:29:40.347000Z",
              updated_at: "2025-06-08T11:18:09.397000Z",
              deleted_at: null,
              created_by: "USR-000000000003",
              updated_by: "USR-000000000012",
            },
            {
              id: 191,
              clinic_id: "34",
              lantum_location_id: "3014987",
              semble_location_id: "null",
              created_at: "2025-05-14T13:29:40.393000Z",
              updated_at: "2025-06-08T11:18:09.430000Z",
              deleted_at: null,
              created_by: "USR-000000000003",
              updated_by: "USR-000000000012",
            },
          ],
        },
        {
          id: 35,
          name: "Bank (London Doctors Clinic)",
          price_bucket_id: "39",
          website_url: "https://www.londondoctorsclinic.co.uk/clinics/bank/",
          address: "27 Queen Street, London, EC4R 1BB",
          longitude: "-.0934277",
          latitude: "51.5118501",
          clinic_website_description: "testtt",
          specific_email_copy: "testt@yopmail.com",
          specific_sms_copy: "testt",
          created_at: "2025-05-07T10:58:37.527000Z",
          updated_at: "2025-06-08T11:19:00.923000Z",
          deleted_at: null,
          created_by: "USR-000000000003",
          updated_by: "USR-000000000012",
          status: "1",
          rooms: [
            {
              id: 229,
              clinic_id: "35",
              lantum_location_id: "3015650",
              semble_location_id: "null",
              created_at: "2025-05-18T13:46:48.497000Z",
              updated_at: "2025-06-08T11:19:00.987000Z",
              deleted_at: null,
              created_by: "USR-000000000003",
              updated_by: "USR-000000000012",
            },
            {
              id: 230,
              clinic_id: "35",
              lantum_location_id: "3015650",
              semble_location_id: "null",
              created_at: "2025-05-18T13:46:48.540000Z",
              updated_at: "2025-06-08T11:19:01.020000Z",
              deleted_at: null,
              created_by: "USR-000000000003",
              updated_by: "USR-000000000012",
            },
          ],
        },
      ],
    },
    allClinicDataByID: {
      // ClinicBooking needs this
      32: {
        id: 32,
        name: "Admin Dorset Rise (London Doctors Clinic)",
        price_bucket_id: "39",
        website_url: "https://clinic1.coma",
        address: "123 Main Streetaa",
        longitude: "12.3456789",
        latitude: "-.0930045",
        clinic_website_description: "<p>5 min walk&nbsp;</p>",
        specific_email_copy: "<p>y</p>",
        specific_sms_copy: "<p>yh</p>",
        created_at: "2025-04-28T10:47:57.737000Z",
        updated_at: "2025-05-20T14:47:33.167000Z",
        deleted_at: null,
        created_by: "USR-000000000014",
        updated_by: "USR-000000000003",
        status: "1",
        rooms: [
          {
            id: 243,
            clinic_id: "32",
            lantum_location_id: "3014744",
            semble_location_id: "null",
            created_at: "2025-05-18T13:52:33.287000Z",
            updated_at: "2025-05-20T15:14:20.767000Z",
            deleted_at: null,
            created_by: "USR-000000000003",
            updated_by: "USR-000000000003",
          },
          {
            id: 244,
            clinic_id: "32",
            lantum_location_id: "3014744",
            semble_location_id: "null",
            created_at: "2025-05-18T13:52:33.337000Z",
            updated_at: "2025-05-20T15:14:20.800000Z",
            deleted_at: null,
            created_by: "USR-000000000003",
            updated_by: "USR-000000000003",
          },
        ],
      },
      34: {
        id: 34,
        name: "Annual Leave (London Doctors Clinic)",
        price_bucket_id: "40",
        website_url: "https://www.londondoctorsclinic.co.uk/clinics/chiswick",
        address: "149 Chiswick High Rd, Chiswick, London, W4 2DT",
        longitude: "-.2575115",
        latitude: "51.4925120",
        clinic_website_description:
          "<p>Randox Health building on Chiswick High Road. The closest station is Turnham Green. Exit Turnham Green Station and head southeast on Chiswick High Road. Continue walking straight on Chiswick High Road for approximately 1 minute until you reach your destination at 149 Chiswick High Road. Along the way, you'll pass various shops, cafes, and restaurants and you can find us directly across the road from Joe &amp; The Juice.</p>",
        specific_email_copy: "<p>It is next to the Chiswick HIgh Street</p>",
        specific_sms_copy: "<p>It is next to the Chiswick HIgh Street</p>",
        created_at: "2025-04-29T13:46:48.053000Z",
        updated_at: "2025-06-08T11:18:09.333000Z",
        deleted_at: null,
        created_by: "USR-000000000014",
        updated_by: "USR-000000000012",
        status: "1",
        rooms: [
          {
            id: 190,
            clinic_id: "34",
            lantum_location_id: "3014987",
            semble_location_id: "null",
            created_at: "2025-05-14T13:29:40.347000Z",
            updated_at: "2025-06-08T11:18:09.397000Z",
            deleted_at: null,
            created_by: "USR-000000000003",
            updated_by: "USR-000000000012",
          },
          {
            id: 191,
            clinic_id: "34",
            lantum_location_id: "3014987",
            semble_location_id: "null",
            created_at: "2025-05-14T13:29:40.393000Z",
            updated_at: "2025-06-08T11:18:09.430000Z",
            deleted_at: null,
            created_by: "USR-000000000003",
            updated_by: "USR-000000000012",
          },
        ],
      },
      35: {
        id: 35,
        name: "Bank (London Doctors Clinic)",
        price_bucket_id: "39",
        website_url: "https://www.londondoctorsclinic.co.uk/clinics/bank/",
        address: "27 Queen Street, London, EC4R 1BB",
        longitude: "-.0934277",
        latitude: "51.5118501",
        clinic_website_description: "testtt",
        specific_email_copy: "testt@yopmail.com",
        specific_sms_copy: "testt",
        created_at: "2025-05-07T10:58:37.527000Z",
        updated_at: "2025-06-08T11:19:00.923000Z",
        deleted_at: null,
        created_by: "USR-000000000003",
        updated_by: "USR-000000000012",
        status: "1",
        rooms: [
          {
            id: 229,
            clinic_id: "35",
            lantum_location_id: "3015650",
            semble_location_id: "null",
            created_at: "2025-05-18T13:46:48.497000Z",
            updated_at: "2025-06-08T11:19:00.987000Z",
            deleted_at: null,
            created_by: "USR-000000000003",
            updated_by: "USR-000000000012",
          },
          {
            id: 230,
            clinic_id: "35",
            lantum_location_id: "3015650",
            semble_location_id: "null",
            created_at: "2025-05-18T13:46:48.540000Z",
            updated_at: "2025-06-08T11:19:01.020000Z",
            deleted_at: null,
            created_by: "USR-000000000003",
            updated_by: "USR-000000000012",
          },
        ],
      },
    },
  },
  getAllHealthScreenData: {
    getAllHealthScreenData: {
      data: [
        {
          id: 1,
          name: "Basic Health Check",
          product_category_id: 2,
        },
      ],
    },
  },
};

export const mockAppointmentData = {
  clinic: {
    productCategory: {
      product_category_id: 1, // 1 for GP, 2 for Health Checks
      title: "GP appointment",
    },
    non_gp_product_id: 102, // Only used if category_id === 2
  },
};

export const mockHealthScreenData = {
  getAllHealthScreenData: {
    data: [
      {
        non_gp_product_id: 101,
        name: "Basic Health Screen",
        status: 1,
        product_specific_booking_page_short_copy:
          "<p>Checks your overall health.</p>",
      },
      {
        non_gp_product_id: 102,
        name: "Advanced Health Screen",
        status: 1,
        product_specific_booking_page_short_copy:
          "<p>Includes ECG, blood work, and full body assessment.</p>",
      },
    ],
  },
};

export const mockData = {
  durationObjectById: {
    1: {
      duration_id: 1,
      duration: "15",
      content: "Best for a single concern or quick follow-up.",
    },
    2: {
      duration_id: 2,
      duration: "30",
      content: "Ideal for 2+ issues or mental health.",
    },
    3: {
      duration_id: 3,
      duration: "45",
      content: "Multiple concerns + extra tests like ECGs.",
    },
    4: {
      duration_id: 4,
      duration: "60",
      content: "Comprehensive consultations and second opinions.",
    },
  },
  languageData: [
    { value: "1", label: "English" },
    { value: "2", label: "Spanish" },
    { value: "3", label: "Hindi" },
  ],
};




export const getAllHealthScreenData = {
    getAllHealthScreenData: {
      data: [
        {
          non_gp_product_id: 101,
          name: "Basic Health Check",
          status: 1,
          product_specific_booking_page_short_copy:
            "A general check-up including blood pressure and BMI.",
          checks : {
            general :[
              "this will bullet point"
            ]
          }
        },
        {
          non_gp_product_id: 102,
          name: "Advanced Health Check",
          status: 1,
          product_specific_booking_page_short_copy:
            "Includes blood tests and cardiovascular screening.",
            checks : {
              general :[
                "this will bullet point"
              ]
            }
        },
        {
          non_gp_product_id: 103,
          name: "Basic Health Check",
          status: 1,
          product_specific_booking_page_short_copy:
            "A general check-up including blood pressure and BMI.",
            checks : {
              general :[
                "this will bullet point"
              ]
            }
        },
        {
          non_gp_product_id: 104,
          name: "Advanced Health Check",
          status: 1,
          product_specific_booking_page_short_copy:
            "Includes blood tests and cardiovascular screening.",
            checks : {
              general :[
                "this will bullet point"
              ]
            }
        },
      ],
    },
    allGPproduct: [], // If needed later
  };
